const request = {
    invalid_input: 'Неверный ввод. {{details}}',
    general: 'Произошла ошибка запроса.',
    /** UNTRANSLATED */
    range_not_satisfiable: 'Range not satisfiable.',
    /** UNTRANSLATED */
    too_many_requests: 'Too many requests.',
};
export default Object.freeze(request);
